import list_icon from '@/assets/img/device/nd68/icon.png'
import { Mars68 } from './mars68'

export class Mars68Pro_Wireless extends Mars68 {
  name: string = 'Mars68_PRO_Wireless'
  icon: string = list_icon
  width: number = 640
  sleepTimeValues = [0, 30, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 4 * 60 * 60, 8 * 60 * 60, 12 * 60 * 60, 18 * 60 * 60]
  sleepTimeBTValues = this.sleepTimeValues
}
